/**
 * @file: orderDateRange.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  PredefinedDateRanges,
  PredefinedDateRangeType,
} from '@euler/model/viewmodel';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

export class OrderDateRangeCriterion extends AbstractSearchCriterionProvider<'orderDateRange'> {
  static readonly shared = new OrderDateRangeCriterion();

  constructor() {
    super('orderDateRange');
  }

  get required(): boolean {
    return true;
  }

  get defaultValue(): PredefinedDateRangeType | undefined {
    return 'recent30days';
  }

  getLabel(): string {
    return '进店时间';
  }

  equals(x: PredefinedDateRangeType, y: PredefinedDateRangeType): boolean {
    return x === y;
  }

  getKey(value: PredefinedDateRangeType): string {
    return value;
  }

  internalGetDisplayText(value: PredefinedDateRangeType): string {
    return PredefinedDateRanges[value]?.text ?? '';
  }

  internalGetOptions(): SearchCriterionOption<PredefinedDateRangeType>[] {
    const keys = Object.keys(PredefinedDateRanges) as PredefinedDateRangeType[];
    return keys.map(value => ({ value }));
  }
}
